/**
 * @class DisposalBackendProvider
 */
function DisposalBackendProvider() {
    let BdcUrl;

    this.setBDCUrl = function setBdcURL(url) {
        BdcUrl = url;
    };

    this.$get = [
        '$q',
        '$http',
        '$log',
        function($q, $http, $log) {
            var self = {};

            /**
             * Get the store's disposals
             * @param  {String} storeId
             * @return {Promise}
             */
            self.getDisposals = function (storeId) {
                return $http.get(BdcUrl + 'disposals/' + storeId).then(function(res) {
                    return res.data;
                });
            };

            /**
             * Add a new disposal
             * @param {String} storeId
             * @param {Object} data
             * @return {Promise}
             */
            self.saveDisposal = function (data) {
                return $http.post(BdcUrl + 'disposal', data).then(function(res) {
                    return res.data;
                });
            };

            return self;
        }
    ];
}

angular
    .module('app.prospection.store.disposalBackend', [])
    .provider('disposalBackend', DisposalBackendProvider);
